import {useContext, useEffect} from 'react';
import { Spin } from 'antd';
import {BrowserRouter} from 'react-router-dom';
import LoadingContext from './contexts/LoadingContext';
import authService from './services/authService';
import AppRoutes from './router';

function App() {
    const { loading } = useContext(LoadingContext);
    useEffect(() => {
        document.title = process.env.REACT_APP_TITLE || 'React App';
        authService.init();
    }, []);
    return (
        <BrowserRouter>
            <Spin size='large' fullscreen={true} spinning={loading}/>
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;
